import React, {Component} from "react"
import PropTypes from "prop-types"
import isString from "lodash/isString"
import IoDown from "react-icons/lib/go/chevron-down"
import IoUp from "react-icons/lib/go/chevron-up"
import ReactHeight from "react-height"

import MD from "@irati/ui/src/Markdown"
import {FormattedMessage} from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"

import {Container} from "./styled"

export const ERROR_TYPE_CHILDREN_NOT_STRING = "The children of ReadMore can only be a (markdown) string"

class ReadMore extends Component {
  static propTypes = {
    children: PropTypes.node,
    maxHeightPx: PropTypes.number
  }

  static defaultProps = {
    children: null,
    maxHeightPx: 94
  }

  state = {
    isOpen: false,
    fullHeight: 0,
    isReadMoreRequired: false
  }

  onHeightReady = (height) => {
    this.setState({
      height,
      fullHeight: this.state.fullHeight < height ? height : this.state.fullHeight,
      isReadMoreRequired: height > this.props.maxHeightPx
    })
  }

  render() {
    const {isReadMoreRequired, isOpen, fullHeight} = this.state
    const {children} = this.props
    if (!children || !isString(children)) {
      return null
    }
    const paragraphs = children.split("\n\n")

    let readMoreStyle = null
    if (isReadMoreRequired) {
      if (isOpen && fullHeight) {
        readMoreStyle = {maxHeight: `${fullHeight}px`}
      } else if (!(isOpen && !fullHeight)) {
        readMoreStyle = {maxHeight: `${this.props.maxHeightPx}px`}
      }
    }

    return (
      <Container
        isRequired={isReadMoreRequired}
        isOpen={!isReadMoreRequired || isOpen}
        onClick={() =>
          this.setState({
            isOpen: !isOpen
          })
        }>
        <div className="readMore_constraint" data-test="constraint" style={readMoreStyle}>
          <ReactHeight onHeightReady={this.onHeightReady}>
            <MD source={paragraphs.join("\n\n")} />
          </ReactHeight>
        </div>

        {isReadMoreRequired && (
          <span className="readMore" data-test="read-more-button">
            <Label>
              <FormattedMessage id={isOpen ? "perks.components.readMore.readLess" : "perks.components.readMore.readMore"} />
              {isOpen ? <IoUp /> : <IoDown />}
            </Label>
          </span>
        )}
      </Container>
    )
  }
}

export default ReadMore
